let logoutAbortController = new AbortController();
export const getLogoutAbortController = () => {
  return logoutAbortController;
};
const resetLogoutAbortController = () => {
  logoutAbortController = new AbortController();
};
export const abortAndResetLogoutAbortController = (abortReason: string) => {
  logoutAbortController.abort(abortReason);
  resetLogoutAbortController();
};
